type LatLng = { longitude: number; latitude: number };

export function isLocalhost(): boolean {
  return ['localhost', '127.0.0.1'].includes(window.location.hostname);
}

export function getDistanceBetween(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const earthRadius = 6371;

  const toRad = (deg: number): number => (deg * Math.PI) / 180;

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const rLat1 = toRad(lat1);
  const rLat2 = toRad(lat2);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(rLat1) * Math.cos(rLat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return earthRadius * c;
}

export function isTargetCity({ longitude, latitude }: LatLng) {
  const userLatitude: number = latitude;
  const userLongitude: number = longitude;

  const cityLocation = {
    newYork: { latitude: 40.70580547970521, longitude: -73.89835810607516 },
    chicago: { latitude: 41.830041091185, longitude: -87.89261757083429 },
    london: { latitude: 51.508014988258985, longitude: -0.08686758435630443 },
    losAngeles: { latitude: 33.9976365871226, longitude: -118.05635183862829 },
    missouri: { latitude: 36.497972, longitude: -92.859586 },
  };

  const distanceNewYork = getDistanceBetween(
    cityLocation.newYork.latitude,
    cityLocation.newYork.longitude,
    userLatitude,
    userLongitude,
  );
  const distanceChicago = getDistanceBetween(
    cityLocation.chicago.latitude,
    cityLocation.chicago.longitude,
    userLatitude,
    userLongitude,
  );
  const distanceLondon = getDistanceBetween(
    cityLocation.london.latitude,
    cityLocation.london.longitude,
    userLatitude,
    userLongitude,
  );
  const distanceLosAngeles = getDistanceBetween(
    cityLocation.losAngeles.latitude,
    cityLocation.losAngeles.longitude,
    userLatitude,
    userLongitude,
  );
  const distanceMissouri = getDistanceBetween(
    cityLocation.missouri.latitude,
    cityLocation.missouri.longitude,
    userLatitude,
    userLongitude,
  );

  return (
    distanceNewYork <= 100 ||
    distanceChicago <= 100 ||
    distanceLondon <= 50 ||
    distanceLosAngeles <= 100 ||
    distanceMissouri <= 220
  );
}
